import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Settings, LogOut, Award, ChevronDown } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './UserDropdown.css';

const UserDropdown = ({ isDarkText }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { user, logout } = useAuth();
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        logout();
        setIsOpen(false);
        navigate('/');
    };

    return (
        <div className="user-dropdown-container" ref={dropdownRef}>
            <button
                className={`user-trigger ${isDarkText ? 'text-dark' : 'text-white'}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="user-avatar">
                    {user.name.charAt(0)}
                </div>
                <span className="user-name-desktop">{user.name.split(' ')[0]}</span>
                <ChevronDown size={14} className={`dropdown-arrow ${isOpen ? 'rotate' : ''}`} />
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="user-menu"
                        initial={{ opacity: 0, y: 10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.95 }}
                    >
                        <div className="menu-header">
                            <p className="menu-email">{user.email}</p>
                            <div className="menu-points">
                                <Award size={14} />
                                <span>{user.points} points</span>
                            </div>
                        </div>

                        <div className="menu-links">
                            {(user.role === 'admin' || user.email === 'superbotboys@gmail.com') && (
                                <Link to="/admin" className="menu-item" onClick={() => setIsOpen(false)}>
                                    <Settings size={18} />
                                    <span>Administration</span>
                                </Link>
                            )}
                            <Link to="/account" className="menu-item" onClick={() => setIsOpen(false)}>
                                <User size={18} />
                                <span>Mon Compte</span>
                            </Link>
                            <button className="menu-item logout-btn" onClick={handleLogout}>
                                <LogOut size={18} />
                                <span>Déconnexion</span>
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default UserDropdown;
